import axios, { AxiosResponse } from 'axios';
import { PROFILE_API_BASE_URL, REPORT_API_BASE_URL, KIT_API_BASE_URL } from '../../constants';
import { Profile, Phone } from '../../models/customerOverview';
import { DownloadReportFormPayload, DownloadReportFormResponse, UpdateNameFormPayload, UpdateNameFormResponse, UpdatePhoneFormPayload, CreatePhoneFormPayload, CommentsPayLoad } from '../../models/profile';

export class ProfileService {

  static async updateName(payload: UpdateNameFormPayload) {
    const response: AxiosResponse<UpdateNameFormResponse> = await axios.put(`${PROFILE_API_BASE_URL}/v1.0/profile/${payload.profileId}/name`, { name: payload.name });
    return response.data;
  }

  static async updatePhone(payload: UpdatePhoneFormPayload) {
    const response: AxiosResponse<Phone> = await axios.put(`${PROFILE_API_BASE_URL}/v1.0/profile/${payload.profileId}/phone`, { phone: payload.phone }, { headers: { 'X-Owner': `${payload.owner}` } });
    return response.data;
  }

  static async createPhone(payload: CreatePhoneFormPayload) {
    const response: AxiosResponse<Phone> = await axios.post(`${PROFILE_API_BASE_URL}/v1.0/profile/${payload.profileId}/phone`, { phone: payload.phone }, { headers: { 'X-Owner': `${payload.owner}` } });
    return response.data;
  }
  static async fetchProfiles(profileIds: string[]): Promise<Profile[]> {
    if (profileIds.length === 0) return [];

    const url = `${PROFILE_API_BASE_URL}/v1.0/profile?id=${profileIds.join(',')}`;
    const response = await axios.get<Profile[]>(url);
    return response.data;
  }

  static async fetchProfilesByEmail(email: string): Promise<Profile[]> {
    const url = `${PROFILE_API_BASE_URL}/v1.0/profile?email=${encodeURIComponent(email)}`;
    try {
      const response = await axios.get<Profile[]>(url);
      return response.data;
    } catch {
      return [];
    }
  }

  static async fetchProfilesByCustomerName(customerName: string): Promise<Profile[]> {
    const url = `${PROFILE_API_BASE_URL}/v1.0/profile?name=${encodeURIComponent(customerName)}`;
    try {
      const response = await axios.get<Profile[]>(url);
      return response.data;
    } catch {
      return [];
    }
  }

  static async downloadReport(payload: DownloadReportFormPayload) {
    const response: AxiosResponse<DownloadReportFormResponse> = await axios.get(`${REPORT_API_BASE_URL}/pdf/presigned/profile/${payload.profileId}?lang=${payload.lang}`, { headers: { 'X-Owner': `${payload.owner}` } });
    return response.data;
  }
  static async updateRemarks(payload: CommentsPayLoad) {
    const response: AxiosResponse<any> = await axios.post(`${KIT_API_BASE_URL}/v1.0/kit/${payload.kitId}/metadata`, {
      metadata: {
        content: payload.content,
        type: 'comment',
      },
    }, { headers: { 'X-Owner': `*` } });
    return response.data;
  }
}
